import { render, staticRenderFns } from "./SliderController.vue?vue&type=template&id=6f85cdaf&lang=pug"
import script from "./SliderController.vue?vue&type=script&lang=js"
export * from "./SliderController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports